'use client'
import { jsx, jsxs } from "react/jsx-runtime";
import { motion } from "motion/react";
import { useEffect, useMemo, useState } from "react";
import { useOklchToRgb } from "../../../hooks/index.js";
import { cn } from "../../../utils/index.js";
import { GlowEffect } from "./GlowEffect.js";
import { glowEffectWrapperVariants } from "./GlowEffectWrapper.variants.js";
const DEFAULT_COLORS = [
    '--color-pennyAccents-4',
    '--color-pennyAccents-8',
    '--color-pennyAccents-9',
    '--color-pennyAccents-11'
];
const DEFAULT_SLOTS = {
    wrapperSlot: '',
    contentSlot: '',
    glowSlot: ''
};
function GlowEffectWrapper({ active = false, children, blur = 'medium', colors = DEFAULT_COLORS, mode = 'colorShift', slots = DEFAULT_SLOTS, duration = 2 }) {
    const [convertedColors, setConvertedColors] = useState([]);
    const { convertMultipleVars, clearCache } = useOklchToRgb();
    const { wrapperSlot, contentSlot, glowSlot } = glowEffectWrapperVariants();
    const wrapperClasses = cn(wrapperSlot(), slots.wrapperSlot);
    const contentClasses = cn(contentSlot(), slots.contentSlot);
    const glowClasses = cn(glowSlot(), slots.glowSlot);
    const colorString = useMemo(()=>JSON.stringify(colors), [
        colors
    ]);
    useEffect(()=>{
        const parsedColors = JSON.parse(colorString);
        setConvertedColors(convertMultipleVars(parsedColors));
        const observer = new MutationObserver(()=>{
            clearCache();
            setConvertedColors(convertMultipleVars(parsedColors));
        });
        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: [
                'class',
                'style'
            ]
        });
        return ()=>observer.disconnect();
    }, [
        colorString,
        convertMultipleVars,
        clearCache
    ]);
    return /*#__PURE__*/ jsxs("div", {
        className: wrapperClasses,
        children: [
            /*#__PURE__*/ jsx(motion.div, {
                className: contentClasses,
                animate: {
                    opacity: active ? 1 : 0
                },
                transition: {
                    duration,
                    ease: 'easeOut'
                },
                children: /*#__PURE__*/ jsx(GlowEffect, {
                    className: glowClasses,
                    colors: convertedColors,
                    mode: mode,
                    blur: blur,
                    duration: duration
                })
            }),
            children
        ]
    });
}
export { GlowEffectWrapper };
